import React, { Component } from 'react';
import 'react-toastify/dist/ReactToastify.css';

import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import AddCircleOutlineRoundedIcon from '@material-ui/icons/AddCircleOutlineRounded';
import {
  shortData,
} from '../../helpers';
import CustomTable from '../../components/CustomTable/CustomTable';
import { RowAction, RowActions } from '../../components/RowActions/RowActions';

const columns = [
  {
    id: 'Id', label: 'Id',
  },
  {
    id: 'ActivityTypeID', label: 'Activity Type ID',
  },
  {
    id: 'ActivityType', label: 'Activity Type',
  },
  {
    id: 'ActivityName', label: 'Activity Name',
  },
  {
    id: 'Level', label: 'Level',
  },
  {
    id: 'Title', label: 'Title',
  },
  {
    id: 'Instruction', label: 'Instruction',
  },
  {
    id: 'action',
    label: 'Action',
  },
];

const useStyles = () => ({
  root: {
    width: '100%',
  },
  container: {
    maxHeight: 440,
  },
  tablewo: {
    cursor: 'pointer',
    '&:hover': {
      background: '#eeeeee',
    },
  },
  mainContainer: {
    // The page container (components/PageContainer) owns padding and width.
    width: '100%',
    minWidth: 0,
  },
  headerContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    margin: 20,
  },
  buttonLink: {
    width: 20,
    height: 20,
    margin: 0,
    padding: 10,
  },
  inputContainer: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  input: {
    width: 300,
    marginRight: 30,
    display: 'flex',
    alignItems: 'end',
  },
});

class table extends Component {
  render() {
    const {
      classes, handleShowEditForm, handleDeleteData, data,
      handleChangePage, handleChangeRowsPerPage, handleShowAddForm, search,
    } = this.props;

    return (
      <>
        <div className={classes.mainContainer}>
          <CustomTable
            icons={[{ icon: AddCircleOutlineRoundedIcon, name: 'Add Config' }]}
            tableName='Activity Config'
            search={search}
            onIconClick={(key) => {
              handleShowAddForm && handleShowAddForm(key);
            }}
            tableHead={columns}
            itemComponent={data.length > 0 ? data.map((element, index) => (
              <TableRow
                className={classes.tablewo}
                tabIndex={-1}
                key={element.id}
              >
                <TableCell>
                  {index + 1}
                </TableCell>
                <TableCell>
                  {element.activityTypeId}
                </TableCell>
                <TableCell>
                  {shortData(element.ActivityTypeConfig?.activityType || '')}
                </TableCell>
                <TableCell>
                  {shortData(element.activityName || '')}
                </TableCell>
                <TableCell>
                  {shortData(element.activitylevel || '')}
                </TableCell>
                <TableCell>
                  {element.title || ''}
                </TableCell>
                <TableCell style={{ width: 200 }}>
                  {element.instruction || ''}
                </TableCell>
                <TableCell>
                  <RowActions>
                    <RowAction
                      kind='edit'
                      onClick={(key) => { handleShowEditForm && handleShowEditForm(key, element); }}
                    />
                    <RowAction
                      kind='delete'
                      onClick={(key) => { handleDeleteData && handleDeleteData(key, element.id); }}
                    />
                  </RowActions>
                </TableCell>
              </TableRow>
            )) : null}
            count={1}
            rowsPerPage={0}
            page={1}
            handleChangePage={handleChangePage && handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage && handleChangeRowsPerPage}
          />
        </div>
      </>

    );
  }
}

export default withStyles(useStyles)(table);
